<template>
	<div class="statistics-page">
		<!-- ROW 2 -->
		<div class="not-admin" v-if="$store.getters.getRole !=='admin' && $store.getters.getRole !=='partner'">
			<div class="vx-row" v-if="currentWidgets.length">

				<div
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/5"
					 v-for="widget in currentWidgets"
				>
					<statistics-card-line
						hideChart
						class="mb-base"
						:icon="widget.icon"
						icon-right
						:color="widget.color"
						:statistic="widget.value"
						:statisticTitle="widget.name"
						:delimited="widget.delimited"
					/>
				</div>
				<div class="vx-col w-full mb-10">
					<div class="vx-row flex justify-end">
						<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/5">
							<v-select
								class="w-full"
								label="title"
								v-model="period"
								:options="periods"
								:clearable="false"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="vx-row" v-if="currentWidgets.length">

				<div
					v-for="(widget, widgetIndex) in currentGraphs"
					:class="{ 'sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2': currentGraphs.length % 2 === 0 || widgetIndex !== 0 }"
					class="vx-col w-full"
					style="margin-bottom: 2.2rem;"
				>
					<statistics-card-line
						:chartOptionsProp="widget.chartOptions"
						:series="widget.series"
						:statisticTitle="widget.name"
						style="width: 100%;"/>

				</div>
			</div>
		</div>

		<div class="admin" v-else>
			<div class="vx-row" v-if="currentWidgets.length || currentMultiWidgets.length">
				<div class="vx-col w-full statistics-page__widgets-col">
					<div class="vx-row">
						<div
							v-for="widget in currentMultiWidgets"
							class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2"
						>
							<statistics-card-line
								hideChart
								class="mb-base"
								:widgets="widget.widgets"
							/>
						</div>
					</div>
				</div>
				<div
					class="vx-col w-full statistics-page__widgets-col"
				>
					<div class="vx-row">
						<div class="vx-col  w-full sm:w-1/2 md:w-1/2 lg:w-1/2 " :class="{
				'xl:w-1/3':  $store.getters.getRole==='manager',
				'xl:w-1/5':  ($store.getters.getRole==='author'),
				'xl:w-1/2':  ($store.getters.getRole==='admin'),
				'xl:w-1/2':  ($store.getters.getRole==='partner')
			}"
							 v-for="widget in currentWidgets">
							<statistics-card-line
								hideChart
								class="mb-base"
								icon-right
								:icon="widget.icon"
								:color="widget.color"
								:statistic="widget.value"
								:statisticTitle="widget.name"
								:delimited="widget.delimited"
							/>
						</div>
					</div>
				</div>

				<div class="vx-col w-full mb-base">
					<div class="vx-row flex justify-between">
						<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4 pb-8 sm:pb-0">
							<div class="vx-row">
								<div class="vx-col w-1/2">
									<vs-custom-button
										:type="page === 0 ? 'filled' : 'border'"
										@click="page = 0"
										class="page-switch-button w-full pl-1 pr-1"
									>{{ $t('general') }}</vs-custom-button>
								</div>
								<div class="vx-col w-1/2">
									<vs-custom-button
										:type="page === 1 ? 'filled' : 'border'"
										@click="page = 1"
										class="page-switch-button w-full pl-1 pr-1"
									>{{ $t('bySites') }}</vs-custom-button>
								</div>
							</div>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4">
							<v-select
								label="title"
								v-model="period"
								:options="periods"
								:clearable="false"
								class="w-full"
							/>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="page === 0 && (adminCurrentGraphs.length || adminCurrentPieGraphs.length)"
				class="vx-row"
			>
				<div
					v-for="widget in adminCurrentPieGraphs"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
					style="margin-bottom: 2.2rem;"
				>
					<PieChartCard
						:chartOptions="chartOptions"
						:series="widget.series"
						:labels="widget.labels"
					/>
				</div>

				<div
					v-for="widget in adminCurrentGraphs"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
					style="margin-bottom: 2.2rem;"
				>
					<statistics-card-line
						:chartOptionsProp="widget.chartOptions"
						:series="widget.series"
						:statisticTitle="widget.name"
					/>
				</div>
			</div>
			<div
				v-if="page === 1 && (adminCurrentSitesGraphs.length || adminCurrentSitesGraphs.length)"
				class="vx-row"
			>
				<div
					v-for="widget in adminCurrentSitesGraphs"
					class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
					style="margin-bottom: 2.2rem;"
				>
					<statistics-card-line
						:chartOptionsProp="widget.chartOptions"
						:series="widget.series"
						:statisticTitle="widget.name"
					/>
				</div>
			</div>
		</div>

		<vx-card v-if="table.length">
			<vs-table max-items="10" pagination :data="table" class="table-th-center">
				<template slot="thead">
					<vs-th v-for="fil in table_fields" class="justify-center text-center">
						{{ fil.title }}
					</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<template v-for="fil in table_fields">
							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								   v-if="fil.field === 'name'">
								<router-link :to="'ticket/' + tr.id">
									{{ tr.name }}
								</router-link>
							</vs-td>

							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								   v-else-if="fil.field === 'subject'">
								{{
									$getDeep(tr.subject, subjects)
								}}
							</vs-td>

							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								   v-else-if="fil.field === 'work_type'">
								{{
									$getDeep(tr.work_type, work_types)
								}}
							</vs-td>

							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								   v-else-if="fil.field === 'manager'">

								{{tr[fil.field]['username']}}
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'income'"
								:class="{'text-center': fil.align && fil.align === 'center'}"
								class="text-success"
							>
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								   v-else-if="fil.field === 'price'">
								{{ tr[fil.field] }}
							</vs-td>

							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
								{{ tr[fil.field] }}
							</vs-td>
							<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
								...
							</vs-td>
						</template>

					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import PieChartCard from "@/components/statistics-cards/PieChartCard";
import databaseManager from "@/mixins/databaseManager";
import axios from '@/axios'
import VSelect from 'vue-select'
import moment from 'moment'

export default {
	mixins: [databaseManager],
	components: {
		StatisticsCardLine,
		PieChartCard,
		VSelect
	},
	data () {
		return {
			page: 0,
			period: {
				// code: 'today',
				// title: this.$t('stats.today')
				title: this.$t('stats.yesterday'),
				code: 'yesterday'
			},
			from: moment().startOf('day').format('YYYY-MM-DD'),
			to: moment().endOf('day').format('YYYY-MM-DD'),
			periods: [
				// {
				// 	title: this.$t('stats.today'),
				// 	code: 'today'
				// },
				{
					title: this.$t('stats.yesterday'),
					code: 'yesterday'
				},
				{
					title: this.$t('stats.currentWeek'),
					code: 'current_week'
				},
				{
					title: this.$t('stats.prevWeek'),
					code: 'last_week'
				},
				{
					title: this.$t('stats.current_month'),
					code: 'current_month'
				},
				{
					title: this.$t('stats.last_month'),
					code: 'last_month'
				},
				{
					title: this.$t('stats.last_three_month'),
					code: 'last_three_month'
				},
				{
					title: this.$t('stats.last_six_month'),
					code: 'last_six_month'
				},
				{
					title: this.$t('stats.last_year'),
					code: 'last_year'
				},
			],
			widgets: [],
			charts: [],
			adminGraphOrders: null,
			manager: {
				prefix: 'manager',
				widgets: [
					// {
					// 	code: 'clientsCount',
					// name:'',
					// 	url: '/stats/get-clients-count'
					// },
					// {
					// 	code: 'authorsCount',
					// name:'',
					// 	url: '/stats/get-authors-count'
					// },
					// {
					// 	code: 'managersCount',
					// name:'',
					// 	url: '/stats/get-managers-count'
					// },
					{
						code: 'income',
						name: this.$t('stats.privateIncome'),
						url: '/stats/get-income',
						color: "success",
						icon: 'CreditCardIcon',
						symbol: ' €',
						type: "widget"
					},
					{
						code: 'successRate',
						name: this.$t('stats.successOrder'),
						url: '/stats/get-success-rate',
						icon: 'ThumbsUpIcon',
						delimited: true,
						color: "primary",
						type: "widget"
					},
					// {
					// 	code: 'incomeProfit',
					// name:'',
					// 	url: '/stats/get-income-profit'
					// },
					// {
					// 	code: 'ordersCount',
					// name:'',
					// 	url: '/stats/get-orders-count'
					// },
					{
						code: 'totalOrdersCount',
						name: this.$t('stats.ordersCount'),
						url: '/stats/get-orders-count',
						icon: 'FileTextIcon',
						color: "info",
						type: "widget"
					},
					{
						code: 'paidOrdersCount',
						name: this.$t('stats.paidOrdersCount'),
						url: '/stats/get-orders-paid-count',
						icon: 'FileTextIcon',
						color: "success",
						type: "widget"
					},
					{
						code: 'waitingOrdersCount',
						name: this.$t('stats.waitingOrdersCount'),
						url: '/stats/get-orders-waiting-percent',
						color: "warning",
						symbol: " %",
						icon: 'AlertCircleIcon',
						type: "widget"
					},

					{
						code: 'graphIncome',
						name: this.$t('stats.graphIncome'),
						url: '/stats/get-graph-income',
						type: 'chart',
						lineName: this.$t("stats.privateIncome")
					},
					{
						code: 'graphOrders',
						name: this.$t('stats.graphOrders'),
						url: '/stats/get-graph-orders',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphOrdersPaid',
						name: this.$t('stats.graphOrdersPaid'),
						url: '/stats/get-graph-orders-waiting',
						type: 'chart',
						lineName: this.$t("stats.waitingOrdersCount") + ", %"
					}

				]
			},
			author: {
				prefix: 'author',
				widgets: [
					{
						code: 'income',
						name: this.$t('stats.income'),
						url: '/stats/get-income',
						color: "success",
						icon: 'CreditCardIcon',
						symbol: ' €',
						type: "widget"
					},
					{
						code: 'ordersCompletedCount',
						name: this.$t('stats.completeOrder'),
						url: '/stats/get-orders-completed-count',
						icon: 'FileTextIcon',
						color: "info",
						type: "widget"
					},
					{
						code: 'successRate',
						name: this.$t('stats.successOrder'),
						url: '/stats/get-success-rate',
						icon: 'ThumbsUpIcon',
						delimited: true,
						color: "primary",
						type: "widget"
					},

					{
						code: 'graphIncome',
						name: this.$t('stats.graphIncomeGlobal'),
						lineName: this.$t("stats.income"),
						url: '/stats/get-graph-income',
						type: 'chart',
					},
					{
						code: 'graphOrders',
						name: this.$t('stats.graphOrders'),
						url: '/stats/get-graph-orders',
						type: 'chart',
						multiple_series: true
					}
				]
			},
			admin: {
				prefix: 'admin',
				widgets: [
					{
						type: 'multiWidget',
						widgets: [
							{
								code: 'managersCount',
								name: this.$t('stats.managersCount'),
								icon: 'GridIcon',
								url: '/stats/get-managers-count',
								color: 'warning',
							},
							{
								code: 'authorsCount',
								name: this.$t('stats.authorsCount'),
								icon: 'Edit3Icon',
								url: '/stats/get-authors-count',
								color: 'success'
							},
							{
								code: 'clientsCount',
								name: this.$t('stats.clientsCount'),
								icon: 'UsersIcon',
								url: '/stats/get-clients-count',
								color: 'info',
							},
						]
					},
					{
						type: 'multiWidget',
						widgets: [
							{
								code: 'ordersCount',
								name: this.$t('stats.ordersCount'),
								icon: 'ListIcon',
								url: '/stats/get-orders-count',
								color: "info"
							},
							{
								code: 'paidOrdersCount',
								name: this.$t('stats.paidOrdersCount'),
								url: '/stats/get-orders-paid-count',
								icon: 'ShoppingCartIcon',
								color: "success"
							},
							{
								code: 'conversion',
								name: this.$t('stats.conversion'),
								url: '/stats/get-conversion-total',
								icon: 'AlertCircleIcon',
								color: "warning",
								symbol: '%'
							},
						]
					},
					{
						code: 'sitesCount',
						name: this.$t('stats.sitesCount'),
						icon: 'GlobeIcon',
						url: '/stats/get-sites-count',
						color: "info",
						type: "widget"
					},
					{
						code: 'successRate',
						name: this.$t('stats.successOrder'),
						url: '/stats/get-success-rate',
						icon: 'ThumbsUpIcon',
						color: "primary",
						delimited: true,
						type: "widget"
					},
					{
						code: 'incomeTotal',
						name: this.$t('stats.incomeTotal'),
						url: '/stats/get-income-total',
						icon: 'CreditCardIcon',
						color: "warning",
						symbol: ' €',
						type: "widget"
					},
					{
						code: 'income',
						name: this.$t('stats.incomeClean'),
						url: '/stats/get-income-profit',
						icon: 'CreditCardIcon',
						color: "success",
						symbol: ' €',
						type: "widget"
					},

					{
						code: 'graphUsers',
						name: this.$t('stats.graphUsers'),
						url: '/stats/get-graph-users',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphIncome',
						name: this.$t('stats.graphAdminIncome'),
						url: '/stats/get-graph-income',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphQualityLevels',
						name: this.$t('stats.graphQualityLevels'),
						url: '/stats/get-graph-quality-levels',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphSubjects',
						name: this.$t('stats.graphSubjects'),
						url: '/stats/get-graph-subjects',
						type: 'chart',
						multiple_series: true
					}
				]
			},
			partner: {
				prefix: 'partner',
				widgets: [
					{
						type: 'multiWidget',
						widgets: [
							// {
							// 	code: 'managersCount',
							// 	name: this.$t('stats.managersCount'),
							// 	icon: 'GridIcon',
							// 	url: '/stats/get-managers-count',
							// 	color: 'warning',
							// },
							// {
							// 	code: 'authorsCount',
							// 	name: this.$t('stats.authorsCount'),
							// 	icon: 'Edit3Icon',
							// 	url: '/stats/get-authors-count',
							// 	color: 'success'
							// },
							{
								code: 'clientsCount',
								name: this.$t('stats.clientsCount'),
								icon: 'UsersIcon',
								url: '/stats/get-clients-count',
								color: 'info',
							},
						]
					},
					{
						type: 'multiWidget',
						widgets: [
							{
								code: 'ordersCount',
								name: this.$t('stats.ordersCount'),
								icon: 'ListIcon',
								url: '/stats/get-orders-count',
								color: "info"
							},
							{
								code: 'paidOrdersCount',
								name: this.$t('stats.paidOrdersCount'),
								url: '/stats/get-orders-paid-count',
								icon: 'ShoppingCartIcon',
								color: "success"
							},
							{
								code: 'conversion',
								name: this.$t('stats.conversion'),
								url: '/stats/get-conversion-total',
								icon: 'AlertCircleIcon',
								color: "warning",
								symbol: '%'
							},
						]
					},
					{
						code: 'sitesCount',
						name: this.$t('stats.sitesCount'),
						icon: 'GlobeIcon',
						url: '/stats/get-sites-count',
						color: "info",
						type: "widget"
					},
					{
						code: 'successRate',
						name: this.$t('stats.successOrder'),
						url: '/stats/get-success-rate',
						icon: 'ThumbsUpIcon',
						color: "primary",
						delimited: true,
						type: "widget"
					},
					{
						code: 'incomeTotal',
						name: this.$t('stats.incomeTotal'),
						url: '/stats/get-income-total',
						icon: 'CreditCardIcon',
						color: "warning",
						symbol: ' €',
						type: "widget"
					},
					{
						code: 'income',
						name: this.$t('stats.incomeClean'),
						url: '/stats/get-income-profit',
						icon: 'CreditCardIcon',
						color: "success",
						symbol: ' €',
						type: "widget"
					},

					{
						code: 'graphUsers',
						name: this.$t('stats.graphUsers'),
						url: '/stats/get-graph-users',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphIncome',
						name: this.$t('stats.graphAdminIncome'),
						url: '/stats/get-graph-income',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphQualityLevels',
						name: this.$t('stats.graphQualityLevels'),
						url: '/stats/get-graph-quality-levels',
						type: 'chart',
						multiple_series: true
					},
					{
						code: 'graphSubjects',
						name: this.$t('stats.graphSubjects'),
						url: '/stats/get-graph-subjects',
						type: 'chart',
						multiple_series: true
					}
				]
			},
			chartOptions: {
				chart: {
					zoom: {
						enabled: false
					},
					toolbar: {
						show: false,
						tools: {
							download: false,
							selection: false,
							customIcons: [{
								icon: '<img src="/images/portrait/small/avatar-s-1.jpg" width="20"/>',
								index: 1,
								title: 'tooltip of the icon',
								class: 'custom-icon',
								click: function (chart, options, e) {
									console.log('clicked custom-icon')
								}
							}]
						}
					},
					selection: {
						enabled: false
					}
				},
				colors: [
					'#7367F0',
					'#28C76F',
					'#EA5455',
					'#FF9F43',
					'#00CFE8',
					'#82868B'
				],

				legend: {
					show: true,
					showForSingleSeries: true,
					position: "bottom"
				},

				selection: {
					enabled: true
				},

				stroke: {
					curve: 'straight'
				},

				xaxis: {
					// categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
					categories: []
				}
			},
			table: [],
			table_fields: [
				{
					field: 'payout_date',
					title: this.$t('stats.date'),
					align: 'center'
				},
				{
					field: 'name',
					title: this.$t('exchange.name'),
					align: 'center'
				},
				{
					field: 'subject',
					title: this.$t('exchange.area'),
					align: 'center'
				},
				{
					field: 'work_type',
					title: this.$t('exchange.type'),
					align: 'center'
				},
				{
					field: 'manager',
					title: this.$t('stats.manager'),
					align: 'center'
				},
				{
					field: 'income',
					title: this.$t('stats.income') + ", €",
					align: 'center'
				}

			],
			work_types: [],
			subjects: []
		}
	},
	watch: {
		period (newVal, oldVal) {
			if (oldVal !== newVal) {
				let from, to;
				if (newVal.code === 'today') {
					to = moment()
					from = moment().startOf('day')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'yesterday') {
					to = moment().subtract(1, 'day')
					from = moment().subtract(1, 'day')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'current_week') {
					to = moment()
					from = moment().startOf('week')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'last_week') {
					to = moment().subtract(1, 'week').endOf('week')
					from = moment().subtract(1, 'week').startOf('week')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'current_month') {
					to = moment()
					from = moment().startOf('month')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'last_month') {
					to = moment().subtract(1, 'month').endOf('month')
					from = moment().subtract(1, 'month').startOf('month')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'last_three_month') {
					to = moment()
					from = moment().subtract(3, 'months')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'last_six_month') {
					to = moment()
					from = moment().subtract(6, 'months')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}
				if (newVal.code === 'last_year') {
					to = moment()
					from = moment().subtract(1, 'year')
					console.log(from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD'))
				}

				if(from !== undefined) 	this.from = from.format('YYYY-MM-DD');
				else 					this.from = null;

				if(to !== undefined) 	this.to = to.format('YYYY-MM-DD');
				else 					this.to = null;

				this.fetchStats()
			}
		}
	},
	computed: {
		currentMultiWidgets() {
			return this.widgets.filter(widget => widget.type === "multiWidget");
		},
		currentWidgets () {
			return this.widgets
				.filter(widget => widget.type === 'widget')
				.map(widget => {
					let val

					if (widget.data.hasOwnProperty('value')) 				val = widget.data.value;
					else if (widget.data.hasOwnProperty('amount')) 			val = widget.data.amount;
					else if (widget.data.hasOwnProperty('count')) 			val = widget.data.count;
					else if (widget.data.hasOwnProperty('count_sites'))		val = widget.data.count_sites;

					let count_fail = widget.data.count_fail;
					let count_success = widget.data.count_success;
					let success_widget_data = null;

					if (isFinite(count_fail) && isFinite(count_success)) success_widget_data = count_success + '/' + count_fail;

					const value = success_widget_data || val;

					return {
						code: widget.code,
						name: widget.name,
						value: widget.symbol !== undefined ? `${value}${widget.symbol}` : value,
						icon: widget.icon,
						color: widget.color,
						delimited: widget.delimited
					}
				});
		},
		currentGraphs () {
			return this.widgets.filter(widget => widget.type === 'chart').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions))

				let series = []

				if (widget.multiple_series) {
					for (const key in widget.data) {
						let serie = {
							name: 'serie',
							data: []
						}
						widget.data[key].forEach(({x, y}) => {
							chartOptions.xaxis.categories.push(x)
							serie.data.push(y)
						})

						if(isNaN(+key)) {
							if(key === 'income') {
								serie.name = this.$t(`stats.${key + "Total"}`)
							} else {
								serie.name = this.$t(`stats.${key}`)
							}
						} else {
							serie.name = key;
						}
						series.push(serie);
					}
				} else {
					let serie = {
						name: 'serie',
						data: []
					}
					widget.data.forEach(({x, y}) => {

						chartOptions.xaxis.categories.push(x)
						serie.data.push(y)

					});
					serie.name = widget.lineName || "11";
					series.push(serie)
				}

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					chartOptions
				}
			})
		},
		adminCurrentPieGraphs() {
			return this.widgets.filter(item => item.type === 'pie').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions));

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series: widget.data.series,
					labels: widget.data.labels,
					chartOptions
				}
			});
		},
		adminCurrentSitesGraphs() {
			return this.widgets.filter(widget => widget.type === 'siteChart').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions))

				let series = []

				for (let key in widget.data) {
					let serie = {
						name: 'serie',
						data: []
					}
					widget.data[key].forEach(({x, y}) => {
						chartOptions.xaxis.categories.push(x)
						serie.data.push(y)
					})

					if(isNaN(+key)) {
						if(key === 'income') {
							serie.name = this.$t(`stats.${key + "Total"}`)
						} else {
							serie.name = this.$t(`stats.${key}`)
						}
					} else {
						serie.name = key;
					}
					series.push(serie);
				}

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					chartOptions
				}
			})
		},
		adminCurrentGraphs () {
			return this.widgets.filter(widget => widget.type === 'chart').map(widget => {
				let chartOptions = JSON.parse(JSON.stringify(this.chartOptions))

				let series = []

				if (widget.multiple_series) {
					for (let key in widget.data) {
						let serie = {
							name: 'serie',
							data: []
						}
						widget.data[key].forEach(({x, y}) => {
							chartOptions.xaxis.categories.push(x)
							serie.data.push(y)
						})

						if(widget.code === "graphSubjects") {
							serie.name = this.$getDeep(+key, this.subjects);
						} else if(isNaN(+key)) {
							if(key === 'income') {
								serie.name = this.$t(`stats.${key + "Total"}`)
							} else {
								serie.name = this.$t(`stats.${key}`)
							}
						} else {
							serie.name = key;
						}
						series.push(serie);
					}
				} else {
					let serie = {
						name: 'serie',
						data: []
					}
					widget.data.forEach(({x, y}) => {

						chartOptions.xaxis.categories.push(x)
						serie.data.push(y)

					})

					serie.name = '11'
					series.push(serie)
				}

				return {
					code: widget.code,
					name: widget.name,
					icon: widget.icon,
					series,
					chartOptions
				}
			})
		},
		adminPaidNewTickets () {
			const widget = this.adminGraphOrders

			for (const key in widget.data) {
				let serie = {
					name: 'serie',
					data: []
				}
				widget.data[key].forEach(({x, y}) => {
					chartOptions.xaxis.categories.push(x)
					serie.data.push(y)
				})
				serie.name = key
				series.push(serie)
			}
		}

	},
	methods: {
		async fetchStats () {
			let role = this.$store.getters.getRole
			const requests = this[role].widgets.map(async (widget) => {
				if(widget.type !== 'multiWidget') {
					let data;

					if(widget.type !== 'widget') {
						data = await this.dbGetGraph(widget.url, this.from, this.to);
					} else {
						data = await this.dbGetGraph(widget.url);
					}

					return {
						...widget,
						data
					}
				} else {
					let newWidget = {
						type: "multiWidget",
						widgets: [],
					};

					for(let sub of widget.widgets) {
						let data = await this.dbGetGraph(sub.url);
						let value = null;

						if(data.count) value = data.count;
						else if(data.value) value = data.value;
						else if(data.conversion) value = data.conversion;

						value = value || 0;

						newWidget.widgets.push({
							statistic: sub.symbol !== undefined ? `${value}${sub.symbol}` : value,
							statisticTitle: sub.name,
							icon: sub.icon,
							color: sub.color
						});
					}

					return newWidget;
				}
			})

			let new_widgets = []
			if (this.$store.getters.isAdmin) {
				try {
					const {
						completed,
						conversion,
						failed,
						new: graph_new,
						paid
					} = (await this.dbGetGraph("/stats/get-graph-orders", this.from, this.to))
					new_widgets.push({
						code: 'admin_new_paid_tickets',
						name: this.$t('stats.newPaidTickets'),
						data: {
							graph_new,
							paid
						},
						type: 'chart',
						multiple_series: true
					});
					new_widgets.push({
						name: this.$t('stats.completedTickets'),
						data: {
							completed,
							failed
						},
						type: 'chart',
						multiple_series: true
					});
					new_widgets.push({
						name: this.$t('stats.conversion'),
						data: {conversion},
						type: 'chart',
						multiple_series: true
					});

					const failReasonsResponse = (await this.dbGetGraph("/stats/get-success-rate", this.from, this.to));
					const failReasons = failReasonsResponse.order_fail_reason;

					if(failReasons.length > 0) {
						new_widgets.push({
							code: 'admin_fail_reasons',
							data: {
								series: failReasons.map(item => item.count),
								labels: failReasons.map(item => item.name)
							},
							type: 'pie',
						});
					}

				} catch(e) {
					console.log(e)
				}
			}
			new_widgets = [...new_widgets, ...(await Promise.all(requests))];
			this.widgets = new_widgets;

			if(!this.$store.getters.isAdmin){
				this.table = this.dbGetPaidOrders(this.from, this.to);
			}
		},
		async getWorks () {
			try {
				this.work_types = (
					await this.$http.get(`/settings/get-work-types`)).data.data
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		},
		async getSubjects () {
			try {
				this.subjects = (
					await this.$http.get(`/settings/get-subjects`)).data.data
			} catch (e) {
				this.$vs.notify({
					title: 'Error',
					text: e.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			}
		},
		async addSitesIncome() {
			const sites = await this.dbGetWebSites();

			for(let site of sites) {
				const websiteFilter = `filter[site_id]=${site.id}`;
				this.admin.widgets.push({
					code: `graphSiteIncome${site.id}`,
					name: site.name,
					url: `/stats/get-graph-income?${websiteFilter}`,
					type: 'siteChart',
					multiple_series: true
				});
			}
		},
		async updateData() {
			try {
				if (!this.$store.getters.isAdmin){
					await this.getWorks()
				} else {
					await this.addSitesIncome();
				}

				await this.getSubjects();

				await this.fetchStats();

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	created () {
		this.updateData();
	}
}
</script>
<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.statistics-page {
	.page-switch-button {
		border: $primary 1px solid;
	}

	&__widgets-col {
		@media screen and (min-width: 1500px) {
			width: 50% !important;
		}
	}

	.table-th-center {
		.vs-table-text {
			justify-content: center;
		}
	}

	.vs-table {
		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}
}

</style>
